const Errno = Object.freeze({
  EPERM: 'EPERM',
  ENOENT: 'ENOENT',
  ESRCH: 'ESRCH',
  EINTR: 'EINTR',
  EIO: 'EIO',
  ENXIO: 'ENXIO',
  E2BIG: 'E2BIG',
  ENOEXEC: 'ENOEXEC',
  EBADF: 'EBADF',
  ECHILD: 'ECHILD',
  EDEADLK: 'EDEADLK',
  ENOMEM: 'ENOMEM',
  EACCES: 'EACCES',
  EFAULT: 'EFAULT',
  ENOTBLK: 'ENOTBLK',
  EBUSY: 'EBUSY',
  EEXIST: 'EEXIST',
  EXDEV: 'EXDEV',
  ENODEV: 'ENODEV',
  ENOTDIR: 'ENOTDIR',
  EISDIR: 'EISDIR',
  EINVAL: 'EINVAL',
  ENFILE: 'ENFILE',
  EMFILE: 'EMFILE',
  ENOTTY: 'ENOTTY',
  ETXTBSY: 'ETXTBSY',
  EFBIG: 'EFBIG',
  ENOSPC: 'ENOSPC',
  ESPIPE: 'ESPIPE',
  EROFS: 'EROFS',
  EMLINK: 'EMLINK',
  EPIPE: 'EPIPE',
  EDOM: 'EDOM',
  ERANGE: 'ERANGE',
  EWOULDBLOCK: 'EWOULDBLOCK',
  EAGAIN: 'EAGAIN',
  EINPROGRESS: 'EINPROGRESS',
  EALREADY: 'EALREADY',
  ENOTSOCK: 'ENOTSOCK',
  EDESTADDRREQ: 'EDESTADDRREQ',
  EMSGSIZE: 'EMSGSIZE',
  EPROTOTYPE: 'EPROTOTYPE',
  ENOPROTOOPT: 'ENOPROTOOPT',
  EPROTONOSUPPORT: 'EPROTONOSUPPORT',
  ESOCKTNOSUPPORT: 'ESOCKTNOSUPPORT',
  EOPNOTSUPP: 'EOPNOTSUPP',
  EPFNOSUPPORT: 'EPFNOSUPPORT',
  EAFNOSUPPORT: 'EAFNOSUPPORT',
  EADDRINUSE: 'EADDRINUSE',
  EADDRNOTAVAIL: 'EADDRNOTAVAIL',
  ENETDOWN: 'ENETDOWN',
  ENETUNREACH: 'ENETUNREACH',
  ENETRESET: 'ENETRESET',
  ECONNABORTED: 'ECONNABORTED',
  ECONNRESET: 'ECONNRESET',
  ENOBUFS: 'ENOBUFS',
  EISCONN: 'EISCONN',
  ENOTCONN: 'ENOTCONN',
  ESHUTDOWN: 'ESHUTDOWN',
  ETOOMANYREFS: 'ETOOMANYREFS',
  ETIMEDOUT: 'ETIMEDOUT',
  ECONNREFUSED: 'ECONNREFUSED',
  ELOOP: 'ELOOP',
  ENAMETOOLONG: 'ENAMETOOLONG',
  EHOSTDOWN: 'EHOSTDOWN',
  EHOSTUNREACH: 'EHOSTUNREACH',
  ENOTEMPTY: 'ENOTEMPTY',
  EUSERS: 'EUSERS',
  EDQUOT: 'EDQUOT',
  ESTALE: 'ESTALE',
  EREMOTE: 'EREMOTE',
  ENOLCK: 'ENOLCK',
  ENOSYS: 'ENOSYS',
  EOVERFLOW: 'EOVERFLOW',
  EIDRM: 'EIDRM',
  ENOMSG: 'ENOMSG',
  EILSEQ: 'EILSEQ',
  EBADMSG: 'EBADMSG',
  EMULTIHOP: 'EMULTIHOP',
  ENODATA: 'ENODATA',
  ENOLINK: 'ENOLINK',
  ENOSR: 'ENOSR',
  ENOSTR: 'ENOSTR',
  EPROTO: 'EPROTO',
  ETIME: 'ETIME',
  ECHRNG: 'ECHRNG',
  EL2NSYNC: 'EL2NSYNC',
  EL3HLT: 'EL3HLT',
  EL3RST: 'EL3RST',
  ELNRNG: 'ELNRNG',
  EUNATCH: 'EUNATCH',
  ENOCSI: 'ENOCSI',
  EL2HLT: 'EL2HLT',
  EBADE: 'EBADE',
  EBADR: 'EBADR',
  EXFULL: 'EXFULL',
  ENOANO: 'ENOANO',
  EBADRQC: 'EBADRQC',
  EBADSLT: 'EBADSLT',
  EDEADLOCK: 'EDEADLOCK',
  EBFONT: 'EBFONT',
  ENONET: 'ENONET',
  ENOPKG: 'ENOPKG',
  EADV: 'EADV',
  ESRMNT: 'ESRMNT',
  ECOMM: 'ECOMM',
  EDOTDOT: 'EDOTDOT',
  ENOTUNIQ: 'ENOTUNIQ',
  EBADFD: 'EBADFD',
  EREMCHG: 'EREMCHG',
  ELIBACC: 'ELIBACC',
  ELIBBAD: 'ELIBBAD',
  ELIBSCN: 'ELIBSCN',
  ELIBMAX: 'ELIBMAX',
  ELIBEXEC: 'ELIBEXEC',
  ERESTART: 'ERESTART',
  ESTRPIPE: 'ESTRPIPE',
  EUCLEAN: 'EUCLEAN',
  ENOTNAM: 'ENOTNAM',
  ENAVAIL: 'ENAVAIL',
  EISNAM: 'EISNAM',
  EREMOTEIO: 'EREMOTEIO',
  ECANCELED: 'ECANCELED',
  EKEYEXPIRED: 'EKEYEXPIRED',
  EKEYREJECTED: 'EKEYREJECTED',
  EKEYREVOKED: 'EKEYREVOKED',
  EMEDIUMTYPE: 'EMEDIUMTYPE',
  ENOKEY: 'ENOKEY',
  ENOMEDIUM: 'ENOMEDIUM',
  ENOTRECOVERABLE: 'ENOTRECOVERABLE',
  EOWNERDEAD: 'EOWNERDEAD',
  ERFKILL: 'ERFKILL',
  EAUTH: 'EAUTH',
  EBADRPC: 'EBADRPC',
  EDOOFUS: 'EDOOFUS',
  EFTYPE: 'EFTYPE',
  ENEEDAUTH: 'ENEEDAUTH',
  ENOATTR: 'ENOATTR',
  ENOTSUP: 'ENOTSUP',
  EPROCLIM: 'EPROCLIM',
  EPROCUNAVAIL: 'EPROCUNAVAIL',
  EPROGMISMATCH: 'EPROGMISMATCH',
  EPROGUNAVAIL: 'EPROGUNAVAIL',
  ERPCMISMATCH: 'ERPCMISMATCH',
  EIPSEC: 'EIPSEC',
  EHWPOISON: 'EHWPOISON',
  ECAPMODE: 'ECAPMODE',
  ENOTCAPABLE: 'ENOTCAPABLE',
  __UNKNOWN_CONSTANT__: '__UNKNOWN_CONSTANT__'
})
export default Errno
// RESERVE BELOW
